$(document).ready(function(){
$('.promo-carousel').slick({
	slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed:2000,
    fade: true,
    cssEase: 'linear'
});
  
var isALARendered;
function ALAcheck() {
  isALARendered = setInterval(function () {
    customALA()
  }, 200);
}
ALAcheck();
function customALA() {
  //console.log('hhh');
  var selector = $('.gallery-navigation--scroller');
  if(selector.length > 0) {
    clearInterval(isALARendered);        
    $('.gallery-navigation--scroller').slick({
  vertical: true,
  verticalSwiping: true,
  draggable: true,
  swipe: true,
  touchMove: true,
  slidesToShow: 5,
  infinite:false,
  slidesToScroll: 1,
  responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
          breakpoint: 720,
          settings: "unslick",
      }
    ]
  });
  }  
}
  

});

jQuery(window).on('resize', function() {
    var viewportWidth = jQuery(window).width();

    if (viewportWidth >= 720) {
        var isALARendered;
        function ALAcheck() {
          isALARendered = setInterval(function () {
            customALA()
          }, 200);
        }
        ALAcheck();
        function customALA() {
          // console.log('hhh');
          var selector = $('.gallery-navigation--scroller');
          if(selector.length > 0) {
            clearInterval(isALARendered);        
            $('.gallery-navigation--scroller').slick({
          vertical: true,
          verticalSwiping: true,
          draggable: true,
          swipe: true,
          touchMove: true,
          slidesToShow: 5,
          infinite:false,
          slidesToScroll: 1,
          responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                }
              },
              {
                  breakpoint: 720,
                  settings: "unslick",
              }
            ]
          });
          }  
        }
    } else {
      $('.gallery-navigation--scroller').slick('unslick');
    }
});

$(document).ready(function(){
  var slideHeight = $(".slideshow-dots-original").find(".flickity-viewport .slideshow-slide").height();
  $(".slideshow-dots-original").find(".flickity-viewport").css("height", slideHeight+'px');
});